import { render, staticRenderFns } from "./ToSubscribe.vue?vue&type=template&id=64e4baa4&scoped=true&"
import script from "./ToSubscribe.vue?vue&type=script&lang=js&"
export * from "./ToSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ToSubscribe.vue?vue&type=style&index=0&id=64e4baa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4baa4",
  null
  
)

export default component.exports